
import { CampaignData } from '@/types/campaigns'
import { computed, defineComponent, PropType, ref, watch } from 'vue'
import CampaignsTable from '@/components/CampaignsTable.vue'
import { Campaign } from '@/Campaign'
import { useStore } from '@/composables/use-store'

export default defineComponent({
  name: 'UserCampaignsDialog',
  components: {
    CampaignsTable
  },

  props: {
    campaigns: {
      type: Array as PropType<CampaignData[]>,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    userName: {
      type: String,
      required: true
    }
  },

  setup (props, { emit }) {
    const store = useStore()
    const dialog = ref(false)

    const tableData = computed(() => props.campaigns.map(campaign => new Campaign(campaign)))

    // all permissions granted in the beginning
    const computePermissions = () => {
      const ret: Record<string, boolean> = {}
      for (const campaign of props.campaigns) {
        ret[campaign.id] = true
      }
      return ret
    }

    const permissionsMap = ref<Record<string, boolean>>(computePermissions())

    // watch campaigns prop for changes
    watch(
      () => props.campaigns,
      () => {
        permissionsMap.value = computePermissions()
      },
      { immediate: true }
    )

    const togglePermission = async (campaignId: string) => {
      const action = permissionsMap.value[campaignId] ? 'permissions/REMOVE_CAMPAIGN_ACCESS' : 'permissions/GRANT_CAMPAIGN_ACCESS'
      await store.dispatch(action, {
        userId: props.userId,
        campaignId
      })
      permissionsMap.value[campaignId] = !permissionsMap.value[campaignId]
    }

    return {
      dialog,
      tableData,
      permissionsMap,
      togglePermission
    }
  }
})
